import React, { useState, ReactNode } from "react";
import User from "../interfaces/user.interface";
import { useQueryClient } from "@tanstack/react-query";

type UserProvider = {
  user: User | undefined;
  updateUser: (user: User | undefined) => void;
};

export const UserContext = React.createContext<UserProvider>({
  /* eslint-disable */
  updateUser: (user) => console.log("user", user),
  user: undefined,
});

type ProviderProps = {
  children: ReactNode;
};

export const ContextUserProvider = ({ children }: ProviderProps) => {
  const [user, setUser] = useState<User | undefined>(undefined);
  const queryClient = useQueryClient();
  const updateUser = (user: User | undefined) => {
    setUser(user);
    if (!user) {
      queryClient.invalidateQueries();
    }
  };

  return (
    <UserContext.Provider value={{ user, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};
